import IconsPage from "./IconsPage";

export default IconsPage;
